import { render, staticRenderFns } from "./__setting_form.vue?vue&type=template&id=768d042c&scoped=true&"
import script from "./__setting_form.vue?vue&type=script&lang=js&"
export * from "./__setting_form.vue?vue&type=script&lang=js&"
import style0 from "./__setting_form.vue?vue&type=style&index=0&id=768d042c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d042c",
  null
  
)

export default component.exports